import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));


const OriginalDate = Date;

function FrenchUTCDate(
  arg1?: string | number | undefined,
  arg2?: number,
  arg3?: number,
  arg4?: number,
  arg5?: number,
  arg6?: number
): Date {
  if ((typeof arg1 === "string" || typeof arg1 === "number") && typeof arg2 === "undefined") {
    return new OriginalDate(arg1);
  }

  if (typeof arg1 === "number" && typeof arg2 === "number") {
    return new OriginalDate(arg1, arg2, arg3 || 1, arg4 || 0, arg5 || 0, arg6 || 0);
  }

  let localDate = new OriginalDate();
  const franceDateString = localDate.toLocaleString("en-US", { timeZone: "Europe/Paris" });
  const franceDate = new OriginalDate(franceDateString);
  const offsetDiff = franceDate.getTime() - localDate.getTime();

  return new OriginalDate(localDate.getTime() + offsetDiff);
}

FrenchUTCDate.now = function () {
  return FrenchUTCDate().getTime();
};

(window as any).Date = FrenchUTCDate;
